import { useTranslation } from 'react-i18next'

import styles from './SkipLinks.module.scss'

export const SkipLinks = () => {
  const { t } = useTranslation('common')
  return (
    <a className={styles.skipLink} href="#main-content">
      {t('button.skip-to-main-content')}
    </a>
  )
}

export default SkipLinks
